import { Card, Skeleton } from "@facade/components/ui";

function ModelCardSkeleton() {
  return (
    <Card className="flex w-full flex-row items-center gap-4 p-6">
      <Skeleton className="size-12 shrink-0 rounded-md" />

      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-4 w-64 max-w-full" />
        <Skeleton className="h-3 w-52 max-w-full" />
      </div>

      <Skeleton className="h-9 w-24 shrink-0 rounded-md" />
      <Skeleton className="size-9 shrink-0 rounded-md" />
    </Card>
  );
}

function FederationCardSkeleton() {
  return (
    <Card className="flex w-full flex-col gap-0 overflow-hidden p-0">
      <div className="flex items-center gap-4 p-6">
        <Skeleton className="size-12 shrink-0 rounded-md" />

        <div className="min-w-0 flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-80 max-w-full" />
            <Skeleton className="h-5 w-20 shrink-0 rounded-full" />
          </div>
          <Skeleton className="h-3 w-32" />
        </div>

        <Skeleton className="h-9 w-24 shrink-0 rounded-md" />
        <Skeleton className="size-9 shrink-0 rounded-md" />
      </div>

      <div className="border-t px-6 py-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="flex min-h-10 items-center gap-3 border-b py-2 last:border-b-0"
          >
            <Skeleton className="size-12 shrink-0 rounded-md" />
            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton className="h-4 w-72 max-w-full" />
              <Skeleton className="h-3 w-16" />
            </div>
            <Skeleton className="h-8 w-20 shrink-0 rounded-md" />
            <Skeleton className="h-8 w-24 shrink-0 rounded-md" />
          </div>
        ))}
      </div>
    </Card>
  );
}

export function ModelsViewSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="relative flex min-h-full w-full flex-1 flex-col p-6"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-8 w-44" />
          <Skeleton className="h-4 w-96 max-w-full" />
        </div>
        <Skeleton className="h-10 w-44 shrink-0 rounded-md" />
      </div>

      <div className="mt-6 flex w-full flex-col gap-3">
        <FederationCardSkeleton />
        <ModelCardSkeleton />
        <ModelCardSkeleton />
      </div>
    </div>
  );
}
